import React from 'react'
import { observer } from 'mobx-react'
import asideModalStore from 'Stores/asideModalStore'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import Checkbox from 'components/ContentBox/Global/Checkbox/Checkbox'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import FormSelectCustom from 'components/UI/AsideModal/Form/FormSelectCustom'
import FormField from 'components/UI/AsideModal/Form/FormField'
import useLocalization from 'hooks/useLocalization'

const BeginLesson = () => {
  const { changeValue, modalValues, check } = asideModalStore
  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      send_link_email: 'Send students a link to the lesson via e-mail',
      select_course: 'Select a course',
      training_course: 'Training course',
      lesson: 'Lesson',
      no_lessons: 'No lessons available',
      select_lesson: 'Select a lesson',
    },
  })
  return (
    <FormFieldset>
      <FormField>
        <FormLabel>{translate?.training_course}:</FormLabel>
        <FormSelectCustom>
          <SelectCustom
            placeholder={translate?.select_course}
            apiLink={`ebooks/books`}
            apiConfParams={{ limit: 999 }}
            valueID={modalValues.course}
            isDisabled
            onChange={() => {}}
          />
        </FormSelectCustom>
      </FormField>
      <FormField>
        <FormLabel>{translate?.lesson}:</FormLabel>
        <FormSelectCustom>
          <SelectCustom
            placeholder={translate?.select_lesson}
            {...(modalValues.course && {
              apiLink: 'ebooks/books/' + modalValues.course,
            })}
            apiGetResult={(result) => result.chapters}
            sortKey='position'
            noOptionsMessage={() => translate?.no_lessons}
            valueID={modalValues.chapter_id}
            onChange={(o) => changeValue(o.id, 'chapter_id')}
            error={check('chapter_id')}
          />
        </FormSelectCustom>
      </FormField>
      <div>
        <Checkbox
          label={translate?.send_link_email}
          name='is_notice'
          checked={modalValues.is_notice}
          onChange={changeValue}
        />
      </div>
    </FormFieldset>
  )
}

export default observer(BeginLesson)
